<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>Lista de Producción</h6>

            <!-- se agg una row mas para la busqueda-->
            <div class="row">

              <!-- Columna de búsqueda -->
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Buscar producción..." @input="fetchData(null)" />
              </div>

              <!-- Columna de fechas -->
              <div class="col-md-3 mb-3">
                <label for="startDate" class="mb-1">Desde</label>
                <input type="date" v-model="startDate" id="startDate" class="form-control" @change="fetchData(null)" />
              </div>
              <div class="col-md-3 mb-3">
                <label for="endDate" class="mb-1">Hasta</label>
                <input type="date" v-model="endDate" id="endDate" class="form-control" @change="fetchData(null)" />
              </div>

            </div>


          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">#</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producción</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad
                    </th>
                    <!-- <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                    </th> -->
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de
                      Terminación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de
                      creación</th>
                    <th class="text-secondary text-center">
                      <router-link :to="{ name: 'Production Create' }" class="text-secondary font-weight-bold text-xs"
                        data-toggle="tooltip" data-original-title="Agregar insumo">
                        Agregar <i class="fa fa-plus"></i>
                      </router-link>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <router-link
                            :to="{ name: 'Production Create', params: { data: JSON.stringify(value) }, props: true }"
                            class="text-secondary font-weight-bold text-xs"
                            data-toggle="tooltip"
                            data-original-title="Editar Registro"
                          >
                            <h6 class="mb-0 text-sm">{{ value?.model?.name ?? "No encontrado" }}</h6>
                          </router-link>
                          <p 
                            class="text-xs text-secondary mb-0" 
                            style="max-width: 250px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                          >
                            {{ value.description }}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ value?.total_quantity }}
                    </td>
                    <!-- <td class="align-middle text-center text-sm">
                      {{ parseFloat(value?.total_price).toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) }}
                    </td> -->
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="{
                        'bg-gradient-warning': value.status === 0,  // Pendiente
                        'bg-gradient-primary': value.status === 1,  // Producción
                        'bg-gradient-success': value.status === 2,  // Terminado
                        'bg-gradient-info': value.status === 3      // Despachado
                      }">
                        {{
                          value.status === 0 ? 'Pendiente' :
                            value.status === 1 ? 'Activo' :
                              value.status === 2 ? 'Terminado' :
                                value.status === 3 ? 'Despachado' : 'Desconocido'
                        }}
                      </span>
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">

                        {{ new Date(value.delivery_date).toLocaleDateString('es-ES') }}                      
                      </span>
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">

                        {{ new Date(value.created_at).toLocaleDateString('es-ES') }}                      
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Production Create', params: { data: JSON.stringify(value) }, props: true }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i :class="value.status > 0 ? 'fa fa-eye' : 'fa fa-pencil-alt'"></i>
                      </router-link>

                      <a v-if="value.status === 0" @click="deleteUser(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="7" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>

                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
export default {
  name: 'ProjectsTable',
  data() {
    return {
      searchQuery: '', // Para el campo de búsqueda
      startDate: '',   // Para la fecha de inicio
      endDate: ''      // Para la fecha de fin
    };
  },
  computed: {
    ...mapGetters('production', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.production.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.production.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['production/links']; // Retorna los links
    },
  },
  methods: {
    async fetchData(pageUrl = null) {

      const params = {
        search: this.searchQuery,
        start_date: this.startDate,
        end_date: this.endDate,
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };

      await this.$store.dispatch('production/fetchData', params);
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("production/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData(null);

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el Empleado');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    }

  },
  mounted() {
    this.fetchData(null); // Llama a fetchUsers cuando el componente se monta
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}
</style>